import { computed, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useRouter } from 'vue-router';
import { useNotificationStore } from 'SharedDir/stores/notification.store';
import { NNotification } from 'SharedDir/declarations/notification';

import { useNotificationList } from './useNotificationList';

export function useNotification(isPage = false) {
  const {
    getAllNotifications,
    clearParameters,
    listTotalCount,
    paginationParams,
    list,
    onRequest,
    refresh,
  } = useNotificationList();

  const router = useRouter();
  const notificationStore = useNotificationStore();
  const { collapseNotificationModal } = storeToRefs(notificationStore);

  const notifications = ref<NNotification.NotificationList>([]);
  const countNotifications = ref(0);

  const unreadNotifications = computed(() => notificationStore.getUnreadNotifications);
  const countUnreadNotifications = computed(() => notificationStore.getCountUnreadNotifications);

  const changeVisibilityNotificationModal = () => {
    notificationStore.setNotificationModal(!collapseNotificationModal.value);
  };

  /**
   * Получить все не прочитанные уведомления
   */
  const getUnreadNotification = async () => {
    await notificationStore.fetchUnreadNotifications();
  };

  /**
   * Отметить все уведомления прочитанными
   */
  const setAllNotificationReaded = async () => {
    await notificationStore.setAllNotificationsAsReaded();

    if (isPage) {
      await getAllNotifications();
    }

    await getUnreadNotification();
  };

  /**
   * Отметить опредленное уведомление
   * @param id
   */
  const setNotificationAsRead = async (id: NNotification.NotificationUid) => {
    await notificationStore.setNotificationAsReaded([id]);

    if (isPage) {
      await getAllNotifications();
    }

    await getUnreadNotification();
  };

  const goToNotificationsPage = () => {
    router.push({ name: 'notifications' });
    changeVisibilityNotificationModal();
  };

  return {
    unreadNotifications,
    countUnreadNotifications,
    changeVisibilityNotificationModal,
    getAllNotifications,
    countNotifications,
    notifications,
    setAllNotificationReaded,
    setNotificationAsRead,
    clearParameters,
    paginationParams,
    list,
    onRequest,
    collapseNotificationModal,
    refresh,
    goToNotificationsPage,
    listTotalCount,
  };
}
